
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'trimStr'})
export class TrimStr implements PipeTransform {
  transform(value: any, options) {
    return value?.length>options?`${value.slice(0,options)}...`:value;
  }
}